export default __webpack_public_path__ + "static/media/person_2.b4125263.png";